
복사

<template>
  <div id="subpkg">
    <main>
 
      <!-- ======================== 히어로 헤더 ======================== -->
      <header class="pkg-hero">
        <div class="hero-bg-pattern"></div>
        <div class="container">
          <div class="hero-inner">
 
            <!-- 국가 선택 드롭다운 -->
            <div class="nation-selector">
              <a href="javascript:void(0)" @click="toggleLayer()" class="nation-toggle">
                <span class="nation-label">DESTINATION</span>
                <h2 class="nation-name">
                  {{ this.natName }}
                  <i class="fa-solid" :class="showLayer ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </h2>
              </a>
 
              <!-- 국가 선택 레이어 -->
              <transition name="fade-drop">
                <div v-if="showLayer" class="nation-layer">
                  <div class="nation-layer-inner">
                    <span class="layer-title">여행지 선택</span>
                    <ul class="nation-list">
                      <li :key="i" v-for="(sn, i) in this.selectableNation">
                        <a :href="`/subList?nt=${sn.nCode}`">
                          <i class="bi bi-geo-alt"></i>
                          {{ sn.nName }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
 
            <!-- 서브 텍스트 -->
            <p class="hero-sub">엔타비글로벌이 엄선한 {{ this.natName }} 여행 상품</p>
          </div>
        </div>
      </header>
 
      <!-- ======================== 상품 리스트 ======================== -->
      <section class="product-section">
        <div class="container">
 
          <!-- 상품 수 표시 -->
          <div class="list-meta">
            <span class="list-count">
              <b>{{ productListForSales.length }}</b>개의 상품
            </span>
            <div class="list-divider-line"></div>
          </div>
 
          <div class="row gx-3 gy-4">
            <div class="col-lg-4 col-md-6 col-sm-12"
                 :key="i"
                 v-for="(product, i) in productListForSales">
              <div class="pkg-card">
 
                <!-- 이미지 영역 -->
                <a class="text-decoration-none link-dark"
                   href="/mongolia"
                   v-if="product.pdtCode == 'T-202358-1683534859762'">
                  <div class="pkg-img-wrap">
                    <div class="pkg-hover-overlay">
                      <span class="pkg-hover-cta">상세보기 <i class="bi bi-arrow-right"></i></span>
                    </div>
                    <img v-if="product.imgName != 'noImage'"
                         :src="`/download/${product.pdtCode}/${product.imgName}`"
                         class="pkg-img" alt="..." />
                    <img v-else
                         :src="`/download/noImage/noImage.jpg`"
                         class="pkg-img" />
                    <div class="badge">
                      <div v-if="product.badgeFlag === 'Y'">
                        <div class="badge1"><small class="badge1-text">{{ product.badge }}</small></div>
                      </div>
                      <div v-if="product.badge2Flag === 'Y'">
                        <div v-if="product.badgeFlag != 'Y'" class="badge1">
                          <small class="badge1-text">{{ product.badge2 }}</small>
                        </div>
                        <div v-else class="badge2" style="margin-left: 180px;">
                          <small class="badge2-text">{{ product.badge2 }}</small>
                        </div>
                      </div>
                      <div v-else></div>
                    </div>
                  </div>
                </a>
 
                <div v-else
                     class="pkg-img-wrap"
                     @click="goToDetail(product.pdtCode, product.salesRoute)"
                     style="cursor: pointer">
                  <div class="pkg-hover-overlay">
                    <span class="pkg-hover-cta">상세보기 <i class="bi bi-arrow-right"></i></span>
                  </div>
                  <img v-if="product.imgName != 'noImage'"
                       :src="`/download/${product.pdtCode}/${product.imgName}`"
                       class="pkg-img" alt="..." />
                  <img v-else
                       :src="`/download/noImage/noImage.jpg`"
                       class="pkg-img" />
                  <div class="badge">
                    <div v-if="product.badgeFlag === 'Y'">
                      <div class="badge1"><small class="badge1-text">{{ product.badge }}</small></div>
                    </div>
                    <div v-if="product.badge2Flag === 'Y'">
                      <div v-if="product.badgeFlag != 'Y'" class="badge1">
                        <small class="badge1-text">{{ product.badge2 }}</small>
                      </div>
                      <div v-else class="badge2" style="margin-left: 180px;">
                        <small class="badge2-text">{{ product.badge2 }}</small>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
                </div>
 
                <!-- 텍스트 영역 -->
                <div class="pkg-body">
                  <!-- 출발 태그 -->
                  <div class="depart-tag" v-if="product.trCd1">
                    <span v-if="product.trCd1 == 'FLT'">
                      <i class="bi bi-airplane-fill"></i> {{ product.cityName }}출발 항공
                    </span>
                    <span v-else-if="product.trCd1 == 'SHP'">
                      <i class="bi bi-tsunami"></i> {{ product.cityName }}출발 선박
                    </span>
                    <span v-else-if="product.trCd1 == 'BUS'">
                      <i class="bi bi-bus-front-fill"></i> 현지출발
                    </span>
                    <span v-else></span>
                  </div>
 
                  <!-- 상품명 -->
                  <h4 class="pkg-title">{{ product.pdtNameKor }}</h4>
 
                  <!-- 설명 -->
                  <p class="pkg-remarks">{{ product.pdtRemarks }}</p>
 
                  <div class="pkg-footer">
                    <!-- 가격 -->
                    <div class="price-wrap">
                      <!-- 가격 표시 -->
                      <div class="d-flex align-items-baseline flex-wrap price-row"
                           v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"
                           @click="goToDetail(product.pdtCode, product.salesRoute)"
                           style="cursor: pointer;">
                        <b class="price-main" v-if="product.discountPercent == 0">
                          {{ getCurrencyFormat(product.pdtPrice) }}<span class="price-won">원</span>
                        </b>
                        <template v-else>
                          <b class="text-muted text-decoration-line-through me-1 price-original">
                            {{ getCurrencyFormat(product.pdtPrice) }}원
                          </b>
                          <i class="bi bi-caret-right-fill text-muted mx-1" style="font-size:.7rem"></i>
                          <span class="price-discount">
                            {{ getCurrencyFormat(product.discountPercent) }}%
                          </span>
                          <span class="price-main ms-1">
                            {{ getCurrencyFormat((product.basic_PdtPrice * 1) + (product.minOptPrice * 1)) }}
                          </span>
                          <span class="price-won"> 원~</span>
                        </template>
                      </div>
                      <!-- 준비중 -->
                      <div class="d-flex align-items-center preparing-wrap" v-else>
                        <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                        <span class="preparing-text">상품을 준비 중입니다</span>
                        <i class="bi bi-question-circle-fill text-danger ms-1"
                           style="cursor: pointer; font-size:.9rem"
                           data-bs-toggle="tooltip" data-bs-placement="top"
                           title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                           @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                      </div>
                    </div>
 
                    <!-- 상세보기 링크 -->
                    <div class="detail-link"
                         @click="goToDetail(product.pdtCode, product.salesRoute)"
                         style="cursor: pointer"
                         v-if="product.pdtCode != 'T-202358-1683534859762'">
                      <i class="bi bi-arrow-right-circle-fill"></i>
                    </div>
                  </div>
                </div>
 
              </div>
            </div>
          </div>
 
        </div>
      </section>
 
    </main>
  </div>
</template>

<link href="../assets/css/style.css" rel="stylesheet" />

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      showLayer: false,        //지역(국가)선택 레이어

      nt: "",                           //상품카테고리(국가기준)
      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가
      ct: "",                           //출발지
      tr: "",                           //출발교통수단
      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리

      productListForSales_org: {},      //국적제거전 엔데트상품리스트      
      productListForSales: {},          //판매용 상품리스트
    };
  },
  created() {
    this.nt = this.$route.query.nt;
    this.ct = this.$route.query.ct;
    this.tr = this.$route.query.tr;
        
    // 페이지생성과 동시에 리스트정보를 get
    this.getNationList();
    this.getPdtCatList();
    this.getProductList_new();            //for new res type


    // this.getProductList();

    // console.log(
    //   "userInfo:",this.$store.state.user,
    // );
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   //this.$router.push({path: '/'});
    //   location.replace("/");
    // }

    if (this.$store.state.user.handlerId != undefined) {
      document.querySelector(".b2cTag").style.display = "none";
    }
    if (this.$store.state.user.email != undefined) {
      document.querySelector(".b2bTag").style.display = "none";
    }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    toggleLayer()
    {
      this.showLayer = !this.showLayer
      //판매상품 중에 엔타비상품 중 국가코드만 추출
      let targetNation = this.productListForSales_org.filter((item) => 
				{
					return item.sellerCode_nt == "Y";
				});
      //console.log("targetNation:",targetNation)

      let values = Object.values(targetNation)
      const key = 'ntCd'
      //ntCd를 추출하되 중복제거한다
      let set = new Set(values.filter(val => typeof val === 'object').map(val => val[key]));
      let result = Array.from(set)

      //선택가능 국가명
      this.selectableNation = this.nationList.filter(obj => result.includes(obj.baseCode)).map(obj => ({nCode: obj.baseCode, nName: obj.codeNameKor}))
      //console.log("selectableNation:",this.selectableNation)
    },

    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList", {});
      this.nationList = nationList;
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      this.natName = natName[0].codeNameKor
    },

    async getPdtCatList() 
    {
      let pdtCatList = await this.$api("/api/pdtCatList", {});
      this.pdtCatList = pdtCatList;
    },

    chage_ntCodeList(c1,c2) 
    {
      this.getProductList(c1, c2)
    },
    
    //메인화면 상품검색
    selSearchCondition(c1, c2){
      this.getProductList(c1, c2)
    },
    
    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      // 전체로컬상품추출 후, 연계상품제외
      // let productListForSales_tmptmp = await this.$api("/api/productListForSales", {param: ['%', sRoute]});

      // asso가 아닌 vrFlag가 Y인 상품만 추출(버라이어티팩 상품)
      let productListForSales_tmptmp = await this.$api("/api/productPrcInfo_m_new", {});
      
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        // return (item.sellerCode_nt == "Y" && item.sellerCode_nd == "N" && item.vrFlag != "Y" && item.golfFlag != "Y" && item.salesRoute != "F" && item.salesRoute != "E")
        return (item.salesRoute != "E" && item.pdtCate.includes("T"))
      })
      
      if(productListForSales_tmp.length > 0) 
      {
        // this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
        this.productListForSales = productListForSales_tmp;        
      }
      
      //console.log("productListForSales_org: ", this.productListForSales_org)
      //console.log("productListForSales: ", this.productListForSales )
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },

    
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    },
    // 숫자콤마표시
    // getCurrencyFormat(value) {
    //   // console.log('value' + value)
    //   return (value+"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
  }
};
</script>

<style scoped>
/* ================================================
  # CSS 변수 — #subpkg 하위 전체 상속
================================================ */
#subpkg {
  --ci-green:       #86cd53;
  --ci-green-dark:  #6ab53e;
  --ci-green-light: #e8f7dc;
  --charcoal:       #1c1c1c;
  --off-white:      #f9faf7;
  --gray-100:       #f4f5f1;
  --gray-200:       #e5e7e1;
  --gray-400:       #9ea89a;
  --gray-600:       #5a635a;
  --text-main:      #1c1c1c;
  --text-sub:       #5a635a;
  --radius-sm:      6px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 2px 10px rgba(28,28,28,0.07);
  --shadow-md:      0 8px 30px rgba(28,28,28,0.13);
 
  background: var(--off-white);
  min-height: 100vh;
}
 
 
/* ================================================
  # 히어로 헤더
================================================ */
.pkg-hero {
  position: relative;
  background: var(--charcoal);
  padding: 5rem 0 4rem;
  overflow: hidden;
  margin-top: -1px;
}
 
/* 배경 패턴 */
.hero-bg-pattern {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 15% 50%, rgba(134,205,83,0.12) 0%, transparent 55%),
    radial-gradient(circle at 85% 30%, rgba(134,205,83,0.08) 0%, transparent 45%);
  pointer-events: none;
}
 
/* 우측 대각선 장식 */
.pkg-hero::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 60px;
  background: var(--off-white);
  clip-path: polygon(0 100%, 100% 0, 100% 100%);
}
 
.hero-inner {
  position: relative;
  z-index: 1;
  text-align: center;
}
 
/* 국가 토글 버튼 */
.nation-toggle {
  display: inline-block;
  text-decoration: none;
  color: inherit;
}
.nation-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 4px;
  color: var(--ci-green);
  margin-bottom: 0.5rem;
}
.nation-name {
  font-size: 3rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -1px;
  margin: 0;
  line-height: 1.1;
  transition: color 0.2s;
}
.nation-name i {
  font-size: 2rem;
  color: var(--ci-green);
  margin-left: 0.4rem;
  vertical-align: middle;
}
.nation-toggle:hover .nation-name { color: var(--ci-green); }
 
.hero-sub {
  color: rgba(255,255,255,0.5);
  font-size: 0.9rem;
  margin-top: 0.8rem;
  margin-bottom: 0;
}
 
@media (max-width: 767px) {
  .pkg-hero { padding: 7rem 0 4rem; }
  .nation-name { font-size: 2rem; }
  .nation-name i { font-size: 1.5rem; }
}
 
 
/* ================================================
  # 국가 선택 드롭다운 레이어
================================================ */
.nation-layer {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 1rem;
  z-index: 100;
  min-width: 200px;
}
.nation-layer-inner {
  background: #fff;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  padding: 1.2rem 1.5rem;
  border-top: 3px solid var(--ci-green);
}
.layer-title {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--gray-400);
  margin-bottom: 0.8rem;
  text-transform: uppercase;
}
.nation-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.nation-list li {
  border-bottom: 1px solid var(--gray-200);
}
.nation-list li:last-child { border-bottom: none; }
.nation-list li a {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.65rem 0.3rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-main);
  text-decoration: none;
  transition: color 0.2s;
}
.nation-list li a i { color: var(--ci-green); font-size: 0.85rem; }
.nation-list li a:hover { color: var(--ci-green-dark); }
 
/* 트랜지션 */
.fade-drop-enter-active, .fade-drop-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.fade-drop-enter-from, .fade-drop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-8px);
}
 
 
/* ================================================
  # 상품 섹션
================================================ */
.product-section {
  padding: 3.5rem 0 6rem;
}
 
/* 상품 수 메타 */
.list-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}
.list-count {
  font-size: 0.88rem;
  color: var(--text-sub);
  white-space: nowrap;
}
.list-count b {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--ci-green-dark);
}
.list-divider-line {
  flex: 1;
  height: 1px;
  background: var(--gray-200);
}
 
 
/* ================================================
  # 상품 카드
================================================ */
.pkg-card {
  background: #fff;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.pkg-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
 
/* 이미지 */
.pkg-img-wrap {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}
.pkg-img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  transition: transform 0.45s ease;
}
.pkg-card:hover .pkg-img { transform: scale(1.05); }
 
/* 호버 오버레이 */
.pkg-hover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(28, 28, 28, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}
.pkg-card:hover .pkg-hover-overlay { opacity: 1; }
.pkg-hover-cta {
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  border: 2px solid var(--ci-green);
  padding: 8px 20px;
  border-radius: 30px;
  background: rgba(134, 205, 83, 0.15);
  letter-spacing: 0.5px;
}
 
/* 뱃지 */
#subpkg .badge { text-align: center; }
#subpkg .badge .badge1 {
  position: absolute;
  top: 0; left: 0;
  background: #e74c3c;
  opacity: 0.88;
  padding: 9px 13px;
  width: 140px;
  border-radius: 0 0 var(--radius-sm) 0;
  z-index: 3;
}
#subpkg .badge .badge1 .badge1-text {
  color: #fff; font-size: 0.95rem; font-weight: 700; padding: 0;
}
#subpkg .badge .badge2 {
  position: absolute;
  top: 0; left: 0;
  background: rgba(255,255,255,0.92);
  padding: 9px 13px;
  width: 140px;
  border-radius: 0 0 var(--radius-sm) 0;
  z-index: 3;
}
#subpkg .badge .badge2 .badge2-text {
  color: var(--charcoal); font-size: 0.95rem; font-weight: 700; padding: 0;
}
 
/* 텍스트 바디 */
.pkg-body {
  padding: 1.1rem 1.2rem 1.2rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}
 
/* 출발 태그 */
.depart-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--ci-green-dark);
  background: var(--ci-green-light);
  border-radius: 20px;
  padding: 3px 10px;
  margin-bottom: 0.6rem;
  width: fit-content;
}
 
/* 상품명 */
.pkg-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.4;
  height: 2.8rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.5rem;
}
 
/* 설명 */
.pkg-remarks {
  font-size: 0.8rem;
  color: var(--gray-400);
  line-height: 1.45;
  height: 2.3rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  flex: 1;
}
 
/* 하단 푸터 (가격 + 화살표) */
.pkg-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.9rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--gray-200);
}
 
/* 가격 */
.price-row { align-items: baseline; }
.price-main {
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--text-main);
}
.price-won {
  font-size: 0.82rem;
  color: var(--gray-400);
  font-weight: 400;
  margin-left: 2px;
}
.price-original { font-size: 0.8rem !important; color: var(--gray-400); }
.price-discount {
  font-size: 0.95rem;
  font-weight: 800;
  color: #e74c3c;
}
.preparing-wrap { gap: 5px; }
.preparing-text { font-size: 0.85rem; font-weight: 600; color: var(--gray-400); }
#subpkg .mbus-icon { width: 1.6rem !important; height: auto !important; }
 
/* 상세보기 아이콘 */
.detail-link {
  flex-shrink: 0;
  font-size: 1.4rem;
  color: var(--gray-200);
  transition: color 0.2s, transform 0.2s;
}
.pkg-card:hover .detail-link {
  color: var(--ci-green);
  transform: translateX(3px);
}
</style>